import { PageWrapper } from 'layout/PublicLayout/Wrappers';
import View from './View';
import Details from './Details';
import { Suspense } from 'react';

export const PublicOffialsView = () => {
    return (
        <PageWrapper>
            <Suspense fallback={<div>Loading...</div>}>
                <View />
            </Suspense>
        </PageWrapper>
    );
};

export const PublicOfficialDetailsView = () => {
    return (
        <PageWrapper>
            <Suspense fallback={<div>Loading...</div>}>
                <Details />
            </Suspense>
        </PageWrapper>
    );
};
